import { parseClientModel } from '../../util/parse';
import { onLoad } from '../../components/form/load';
import jQuery from 'jquery';

interface TypeMap {
	type: string,
	renderType: string,
	dataFormat?: string
}

interface MemberModel extends kendo.data.PivotTupleModel {
	parentName?: string;
}

interface MeasureField {
	field: string;
}

export default async function initialize() {
	await initializePivot();

	onLoad(async (container) => {
		await initializePivot(container);
	})
}

async function initializePivot(container?: JQuery) {
	let pivots = jQuery('.report-pivot', container);

	if (pivots.length > 0) {
		await import(/* webpackChunkName: "kendo-dataviz" */ '../../plugins/kendo/dataviz');

		pivots.each((_, e) => {
			var options: kendo.ui.PivotGridOptions = parseClientModel(jQuery('.pivot-model', e)) as kendo.ui.PivotGridOptions;
			const fields = options.dataSource.schema.model.fields;
			const measures = options.dataSource.schema.cube.measures as { [caption: string]: MeasureField; };

			const fieldMap: { [id: string]: TypeMap; } = {};
			const measureMap: { [caption: string]: TypeMap; } = {};

			for (let fieldId in fields) {
				const field = fields[fieldId];
				fieldMap[fieldId] = field

				var measureCaption = Object.keys(measures).find(key => measures[key].field === fieldId);
				if (measureCaption) {
					measureMap[measureCaption] = field;
				}
			}

			options.rowHeaderTemplate = HeaderTemplate;
			options.columnHeaderTemplate = HeaderTemplate;
			options.dataCellTemplate = DataCellTemplate;

			let pivot = jQuery('.pivot-grid', e)
				.kendoPivotGrid(options)
				.data("kendoPivotGrid");

			let config = jQuery('.pivot-config', e)
				.kendoPivotConfigurator({
					dataSource: pivot.dataSource,
					height: options.height
				})
				.data("kendoPivotConfigurator");

			jQuery(window).on("resize", () => {
				pivot.resize();
				config.resize();
			});

			function HeaderTemplate(args) {
				let member = args.member as MemberModel

				if (member.parentName && member.parentName in fieldMap) {
					return formatValue(member.caption, fieldMap[member.parentName]);
				}

				if (!member.caption) {
					return member.name;
				}

				return member.caption;
			}

			function DataCellTemplate(args) {
				let key = null;

				// measure is only specified when there are many
				if (args.measure?.name && measureMap[args.measure.name]) {
					key = args.measure.name;
				}
				else if (!args.measure?.name && Object.keys(measureMap).length == 1) {
					key = Object.keys(measureMap)[0];
				}

				if (key) {
					return formatValue(args.dataItem.value, measureMap[key]);
				}

				return args.dataItem.fmtValue
			}
		});
	}
}

function formatValue(value: any, field: TypeMap): string {
	if (value === null || value === '') {
		return field.type === 'string' ? 'n/a' : '&nbsp;';
	}

	if (field.renderType == 'Date') {
		return kendo.toString(kendo.parseDate(value), field.dataFormat ?? "d");
	}

	if (field.renderType == 'Float') {
		return kendo.toString(kendo.parseFloat(value), field.dataFormat ?? "n");
	}

	if (field.renderType == 'Integer') {
		return kendo.toString(kendo.parseInt(value), field.dataFormat ?? "n0");
	}

	return value;
}
